/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DataTable from 'react-data-table-component';
import TableLoader from '../../../../components/TableLoader';

import { Container } from './styles';

interface TableProps {
  data: any;
  columns: any[];
  loading: boolean;
  emptyText: string;
  totalRows: number;
  perPage: number;
  onChangePage(newPage: number): Promise<void>;
  onChangeRowsPerPage(newPerPage: number, OldPerPage: number): Promise<void>;
}

const paginationRowsPerPageOptions = [10, 15, 20, 25, 30, 50];

const TarifasTable: React.FC<TableProps> = ({
  data,
  loading,
  columns,
  emptyText,
  totalRows,
  perPage,
  onChangePage,
  onChangeRowsPerPage,
}) => {
  return (
    <Container>
      <DataTable
        noHeader
        fixedHeader
        data={data}
        columns={columns}
        progressPending={loading}
        progressComponent={<TableLoader />}
        noDataComponent={<div className="emptyText">{emptyText}</div>}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={perPage}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        paginationComponentOptions={{
          rangeSeparatorText: 'de',
          rowsPerPageText: 'Linhas por página',
        }}
      />
    </Container>
  );
};
export default TarifasTable;
